import { ElementDetailCollapse } from "../../../../shared/Components/ElementDetailCollapse";
import { EntityComparative } from "../../../../shared/Domain/EntityComparative";
import { AdapterGenerico } from "../../../../shared/Infraestructure/AdapterGenerico";
import { LanguageTranslate } from "../../../../shared/Infraestructure/LanguageTranslate";
import { EntityDocumentoContent, EntityListContent } from "../../Domain/EntityListContent";
import { EntityRequestDownloadFile } from "../../Domain/EntityRequestDownloadFile";
import { keyModal } from "../../Domain/EntityUtils";

interface ContainerProps {
    listContent: EntityListContent<EntityComparative>;
    viewDocument: (payload: EntityRequestDownloadFile, code: string) => Promise<any>;
    openModal: (key: keyModal, dataComplete?: any) => void;
    show: boolean;
    copyCodeItem: Function;
}
const languageTranslate = LanguageTranslate();
const itemColors = ['#4C6FFF', '#0E9F86', '#E8622C', '#0B2A5B', '#8B5CF6'];

const groupDocumentos = (arr: EntityDocumentoContent[]) => {
    return arr.reduce((prev, current) => {
        const indexFinded = prev.findIndex(row => row.keyGroup === current.keyGroup);
        indexFinded === -1 ? prev.push({ ...current, list: [current] }) : prev[indexFinded].list.push(current);
        return prev;
    }, [] as (EntityDocumentoContent & { list: EntityDocumentoContent[] })[])
}

const findLabel = (headerTable: { label: string; key: string }[], key: string) => headerTable?.find(row => row.key === key)?.label || '';

export const ViewComparativo = (props: ContainerProps) => {
    if (!props.show) return null;

    return (
        <>
            <div className='ComparativeDetailCard'>
                <div className='ComparativeDetailCard-titleRow'>
                    <span className='ComparativeDetailCard-title'>{languageTranslate.moduloGenericDetail.itemDetail.textTitle}</span>
                    {
                        props.listContent.detail.paisCodigo &&
                        <span className='ComparativeDetailCard-countryBadge'>
                            <span className={`ComparativeDetailCard-flag fi fi-${props.listContent.detail.paisCodigo.toLowerCase()} fis`} />
                            <span className='ComparativeDetailCard-countryCode'>{props.listContent.detail.paisCodigo.toUpperCase()}</span>
                        </span>
                    }
                </div>

                <div className='ComparativeDetailCard-field'>
                    <span className='ComparativeDetailCard-label'>{languageTranslate.moduloGenericDetail.itemDetail.textEmpresa}</span>
                    <span className='ComparativeDetailCard-value'>{props.listContent.detail.empresa}</span>
                </div>

                <div className='ComparativeDetailCard-field'>
                    <span className='ComparativeDetailCard-label'>{languageTranslate.moduloGenericDetail.itemDetail.textProveedor}</span>
                    <span className='ComparativeDetailCard-value'>{props.listContent.detail.proveedor}</span>
                </div>

                <div className='ComparativeDetailCard-field'>
                    <span className='ComparativeDetailCard-label'>{languageTranslate.moduloGenericDetail.itemDetail.textOT}</span>
                    <span className='ComparativeDetailCard-value'>{props.listContent.detail.ot}</span>
                </div>

                <div className='ComparativeDetailCard-row'>
                    <div className='ComparativeDetailCard-field'>
                        <span className='ComparativeDetailCard-label'>{languageTranslate.moduloGenericDetail.itemDetail.textTipoPago}</span>
                        <span className='ComparativeDetailCard-value'>{props.listContent.detail.tipoPago}</span>
                    </div>
                    <div className='ComparativeDetailCard-field'>
                        <span className='ComparativeDetailCard-label'>{languageTranslate.moduloGenericDetail.itemDetail.textTerminoPago}</span>
                        <span className='ComparativeDetailCard-value'>{props.listContent.detail.terminoPago}</span>
                    </div>
                </div>

                {
                    props.listContent.detail.comentario &&
                    <div className='ComparativeDetailCard-description'>
                        <span className='ComparativeDetailCard-label'>{languageTranslate.moduloGenericDetail.itemDetail.textDescripcion}</span>
                        <p className='ComparativeDetailCard-value mb-0'>{props.listContent.detail.comentario}</p>
                    </div>
                }

                {
                    (props.listContent.detail.global || props.listContent.detail.multiProveedor) ?
                        <div className='d-flex GroupBadge'>
                            { props.listContent.detail.global ? <div className="badgeCustom badgeCustom-global">{languageTranslate.moduloGenericDetail.itemDetail.textContratoMarco} <i className="fa-solid fa-file-contract" /> </div> : null }
                            { props.listContent.detail.multiProveedor ? <div className="badgeCustom badgeCustom-multiproveedor">{languageTranslate.moduloGenericDetail.itemDetail.textMultiProveedor} <i className="fa-solid fa-users" ></i></div> : null }
                        </div>
                    : null
                }
            </div>

            <ElementDetailCollapse
                title={languageTranslate.moduloGenericDetail.itemProducto.textTitle}
                isOpenDefault
            >
                {
                    props.listContent.producto.map((row, index) => (
                        <div className='ProductoItemCard' key={row.id || index} onClick={() => props.openModal('product', row)}>
                            <div className='ProductoItemCard-header'>
                                <div className='ProductoItemCard-icon' style={{ backgroundColor: itemColors[index % itemColors.length] }}>
                                    <i className='fa-solid fa-box' />
                                </div>
                                <span className='ProductoItemCard-name'>{row.descripcion}</span>
                            </div>
                            <div className='ProductoItemCard-columns'>
                                <div className='ProductoItemCard-column'>
                                    <span className='ProductoItemCard-label'>{findLabel(languageTranslate.moduloGenericDetail.itemProducto.headerTable, 'cantidad')}</span>
                                    <span className='ProductoItemCard-value'>{row.cantidad} {row.unidad}</span>
                                </div>
                                <div className='ProductoItemCard-column'>
                                    <span className='ProductoItemCard-label'>{findLabel(languageTranslate.moduloGenericDetail.itemProducto.headerTable, 'precioUnitario')}</span>
                                    <span className='ProductoItemCard-value'>{row.precioUnitario}</span>
                                </div>
                                <div className='ProductoItemCard-column'>
                                    <span className='ProductoItemCard-label'>{findLabel(languageTranslate.moduloGenericDetail.itemProducto.headerTable, 'subTotal')}</span>
                                    <span className='ProductoItemCard-value'>{row.subTotal}</span>
                                </div>
                            </div>
                        </div>
                    ))
                }
                <div className='ComparativeDetailCard-totalRow'>
                    <span className='ComparativeDetailCard-totalLabel'>{languageTranslate.moduloGenericDetail.itemProducto.textMontoTotal}</span>
                    <span className='ComparativeDetailCard-totalAmount'>$ {AdapterGenerico.formatoDinero(props.listContent.producto.reduce((prev, current) => prev + current.subTotalTypeNumber, 0))}</span>
                </div>
            </ElementDetailCollapse>

            <ElementDetailCollapse
                title={languageTranslate.moduloGenericDetail.itemNotas.textTitle}
                isOpenDefault
                headerAction={
                    <button type='button' className='ElementDetailCollapse-addBtn' onClick={() => props.openModal('notes')}>
                        <i className='fa-solid fa-plus' /> Agregar nota
                    </button>
                }
            >
                {
                    props.listContent.notas.map((row, index) => (
                        <div className={`NotaItemCard ${row.action === 'NUEVA NOTA DEVUELTO' ? 'CustomNotaDevuelto' : ''}`} key={index}>
                            <p className='NotaItemCard-text'>{row.observacion}</p>
                            <div className='NotaItemCard-footer'>
                                <span className='NotaItemCard-user'>{row.usuario}</span>
                                <span className='NotaItemCard-date'>{row.fecha}</span>
                            </div>
                        </div>
                    ))
                }
            </ElementDetailCollapse>

            <ElementDetailCollapse title={languageTranslate.moduloGenericDetail.itemBitacora.textTitle}>
                {
                    props.listContent.bitacora.map((row, index) => (
                        <div className='BitacoraItem' key={index}>
                            <span className='BitacoraItem-meta'>
                                {row.fecha} — <strong>{row.usuario}</strong>{row.perfil ? ` (${row.perfil})` : ''}
                            </span>
                            {
                                (row.descripcion || row.accion) &&
                                <span className='BitacoraItem-comment'> · "{row.descripcion || row.accion}"</span>
                            }
                        </div>
                    ))
                }
            </ElementDetailCollapse>

            <ElementDetailCollapse title={languageTranslate.moduloGenericDetail.itemDocumentos.textTitle}>
                {
                    groupDocumentos(props.listContent.documento).map((group, groupIndex) => (
                        group.list.map((file, fileIndex) => (
                            <div className='DocumentoItemCard' key={`${groupIndex}-${fileIndex}`} onClick={() => props.viewDocument(file.path, file.code)}>
                                <div className='DocumentoItemCard-icon' style={{ backgroundColor: itemColors[groupIndex % itemColors.length] }}>
                                    <i className='fa-solid fa-file-lines' />
                                </div>
                                <div className='DocumentoItemCard-info'>
                                    <span className='DocumentoItemCard-title'>{group.textGroup}</span>
                                    <span className='DocumentoItemCard-subtitle'>{file.name}</span>
                                </div>
                                <i className='fa-solid fa-download DocumentoItemCard-download' />
                            </div>
                        ))
                    ))
                }
            </ElementDetailCollapse>
        </>
    )
}